import moment from "moment";
import { useState, useRef } from "react";
import { Card, Col, Form, Modal, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ConsentimientoTeleSalud from "../../autoagendamiento/ConsentimientoTeleSalud";
import SignatureCanvas from "react-signature-canvas";
import { useEffect } from "react";
import Get from "../../../api/Get";
import {
  PARTNER_GET_ACTIVE_SIN_TOKEN,
  SAVE_APPOINTMENT_SIN_TOKEN,
  SAVE_LINK_PATIENT_AUTOAGENDAMIENTO,
  TIPO_DOCUMENTO_PACIENTE_COLOMBIA,
} from "../../../api/Routes";
import { getIpPublic } from "../../../utils/getIpPublic";
import { getSource } from "../../../utils/getSource";
import Post from "../../../api/Post";
import Select from "react-select";
import { getLengthDN } from "./ClbForm";
import Loading from "../Loading";
import ModalInformacionParaPago from "../../pagos/ModalInformacionParaPago";
import { Field, Formik } from "formik";
import * as Yup from "yup";

const ClbConfirmarServicio = ({
  data,
  setData,
  setCurrentScreen,
  configuration,
  classTop = "",
  setPayment,
  setPaymentStatus,
}) => {
  const { t } = useTranslation();
  const [items, setItems] = useState({
    showModal: false,
    checkedTerm: false,
    isReservating: false,
    hasCopayment: data.patient.account.hasCopayment || false,
    citaCostoMoneda: {
      costo: null,
      currency: "",
    },
    choiceTypeInput: "",
    openConfirmacionDeclinar: false,
  });
  const [openModalPago, setOpenModalPago] = useState(false);
  const [objPayment, setObjPayment] = useState(null);

  const [dataRecord, setDataRecord] = useState("");
  const sigCanvas = useRef({});
  const clear = () => sigCanvas.current.clear();
  //secion de firma y extra data
  const [errors, setErrors] = useState({
    firma: {
      error: false,
      text: "",
    },
    identityDocumentType: {
      error: false,
      text: "",
    },
    documentNumber: {
      error: false,
      text: "",
    },
    fullName: {
      error: false,
      text: "",
    },
    patientRelationship: {
      error: false,
      text: "",
    },
  });
  const [dataAcudiente, setDataAcudiente] = useState({
    tipoDocumentoOpt: [],
    identityDocumentType: "",
    documentNumber: "",
    fullName: "",
    tipoPacienteOpt: [],
    patientRelationship: "",
    aceptacionAcudiente: false,
    hasLength: 10,
  });
  //checamos varias cosas antes de enviar la consulta
  const [allowDoAppt, setAllowDoAppt] = useState(true);

  //checamos si tiene copayment la cuenta
  useEffect(() => {
    const idEspecialidad = data.especialidadId;
    const especilidadDetail =
      data.patient.account?.specialtyDurationList?.filter(
        (item) => item.especialty?.id === idEspecialidad
      );
    let hasCopaymentEspeciality = false;
    if (especilidadDetail.length) {
      hasCopaymentEspeciality = especilidadDetail[0].hasCopayment ?? false;
      const costo = especilidadDetail[0].amountPayment ?? null;
      const currency = especilidadDetail[0].currency?.code ?? null;
      setItems((prev) => ({
        ...prev,
        citaCostoMoneda: {
          costo: costo,
          currency: currency,
        },
        hasCopayment:
          data.patient.account.hasCopayment && hasCopaymentEspeciality,
      }));
    }
  }, []);

  //servicios
  useEffect(() => {
    const fetchApi = async () => {
      try {
        const response = await Get({
          url: TIPO_DOCUMENTO_PACIENTE_COLOMBIA,
          noToken: true,
        });
        setDataAcudiente((prev) => ({
          ...prev,
          tipoDocumentoOpt: response.data,
        }));
      } catch (error) {
        setDataAcudiente((prev) => ({
          ...prev,
          tipoDocumentoOpt: [],
        }));
      }
      try {
        const response = await Get({
          url: `${PARTNER_GET_ACTIVE_SIN_TOKEN}/${data.patient.account.id}`,
          noToken: true,
        });
        setDataAcudiente((prev) => ({
          ...prev,
          tipoPacienteOpt: response.data.data.response,
        }));
      } catch (error) {
        setDataAcudiente((prev) => ({
          ...prev,
          tipoPacienteOpt: [],
        }));
      }
    };
    fetchApi();
  }, []);

  //console.log(data)
  const handleMakeAppointment = async (confirmado) => {
    try {
      if (confirmado) {
        if (items.checkedTerm) {
          let doAppt = allowDoAppt;
          if (
            sigCanvas.current.isEmpty() ||
            dataAcudiente.aceptacionAcudiente
          ) {
            const errorCopy = { ...errors };
            if (sigCanvas.current.isEmpty()) {
              errorCopy.firma.error = true;
              errorCopy.firma.text = "Firma requerida";
              doAppt = false;
            } else {
              errorCopy.firma.error = false;
              errorCopy.firma.text = "";
            }
            if (dataAcudiente.fullName === "") {
              errorCopy.fullName.error = true;
              errorCopy.fullName.text = "Campo requerido";
              doAppt = false;
            } else {
              errorCopy.fullName.error = false;
              errorCopy.fullName.text = "";
            }
            if (dataAcudiente.documentNumber === "") {
              errorCopy.documentNumber.error = true;
              errorCopy.documentNumber.text = "Campo requerido";
              doAppt = false;
            } else {
              errorCopy.documentNumber.error = false;
              errorCopy.documentNumber.text = "";
            }
            if (dataAcudiente.patientRelationship === "") {
              errorCopy.patientRelationship.error = true;
              errorCopy.patientRelationship.text = "Campo requerido";
              doAppt = false;
            } else {
              errorCopy.patientRelationship.error = false;
              errorCopy.patientRelationship.text = "";
            }
            if (dataAcudiente.identityDocumentType === "") {
              errorCopy.identityDocumentType.error = true;
              errorCopy.identityDocumentType.text = "Campo requerido";
              doAppt = false;
            } else {
              errorCopy.identityDocumentType.error = false;
              errorCopy.identityDocumentType.text = "";
            }
            console.log(errorCopy);
            setErrors(errorCopy);
          }
          const responseIp = await getIpPublic();
          console.log(doAppt);
          if (doAppt) {
            setItems((prev) => ({
              ...prev,
              isReservating: true,
            }));
            let cAdrress = {
              id: "",
              roadType: data.patient.colombusAddress.roadType?.id
                ? data.patient.colombusAddress.roadType
                : null,
              streetField1: data.patient.colombusAddress.streetField1,
              streetField2: data.patient.colombusAddress.streetField2,
              streetField3: data.patient.colombusAddress.streetField3,
              propertyNumber: data.patient.colombusAddress.propertyNumber,
              propertyType: data.patient.colombusAddress.propertyType?.id
                ? data.patient.colombusAddress.propertyType
                : null,
              propertyTypeAdditional: data.patient.colombusAddress
                .propertyTypeAdditional?.id
                ? data.patient.colombusAddress.propertyTypeAdditional
                : null,
              unitNumber: data.patient.colombusAddress.unitNumber,
            };
            const firma = sigCanvas.current
              .getTrimmedCanvas()
              .toDataURL("image/png");
            const base64result = firma.split(",")[1];
            let d = {
              source: getSource(data.source),
              account: data.patient.account,
              appointmentStatus: items.hasCopayment
                ? "PendientePago"
                : getSource(data.source).id === 8 ||
                  getSource(data.source).id === 10 ||
                  getSource(data.source).id === 11 ||
                  !data.patient.account.automaticValidation
                ? "Pendiente"
                : "Pagada",
              eps: data.patient.eps?.id ? data.patient.eps : null,
              tipoPlan: data.patient.tipoPlan,
              patient: {
                ...data.patient,
                dateOfBirthday: moment(data.patient.dateOfBirthday).format(
                  "DD-MM-YYYY"
                ),
                ocupacion: data.patient.ocupacion?.id
                  ? data.patient.ocupacion
                  : null,
                localidad: data.patient.localidad?.id
                  ? data.patient.localidad
                  : null,
                identityDocumentType: data.patient.identityDocumentType,
                patientRelationship: data.patient.patientRelationship?.id
                  ? data.patient.patientRelationship
                  : null,
                colombusAddress: cAdrress,
                country: data.patient.country?.id ? data.patient.country : null,
                municipio: data.patient.municipio?.id
                  ? data.patient.municipio
                  : null,
                state: data.patient.state?.id ? data.patient.state : null,
                countryBirth: data.patient.countryBirth?.id
                  ? data.patient.countryBirth
                  : null,
                eps: data.patient.eps?.id ? data.patient.eps : null,
                titular: data.patient.titular ? data.patient.titular : null,
              },
              schedule: data.schedule,
              especialty: {
                id: data.especialidadId,
              },
              peso: data.patient?.peso ?? 0.0,
              talla: data.patient?.talla ?? 0.0,
              motivoConsulta: data.patient.sintomas,
              linkPatient: data.patient.linkPatient,
              choiceType: items.choiceTypeInput,
              expediente: data.patient.expediente,
              legalWarnings: [
                {
                  acceptPatient: "approved",
                  ipAddress: responseIp,
                  legalWarningType: "InformedConsent",
                  dataRecord: dataRecord,
                  url_photo: base64result,
                  legalAgent: dataAcudiente.aceptacionAcudiente
                    ? {
                        fullName: dataAcudiente.fullName,
                        documentNumber: dataAcudiente.documentNumber,
                        identityDocumentType: {
                          id: dataAcudiente.identityDocumentType,
                        },
                        patientRelationship: {
                          id: dataAcudiente.patientRelationship,
                        },
                      }
                    : null,
                },
              ],
            };

            console.log(d);

            const responseCita = await Post({
              url: SAVE_APPOINTMENT_SIN_TOKEN,
              data: d,
              header: false,
            });
            setItems((prev) => ({
              ...prev,
              isReservating: false,
            }));
            if (responseCita.data.state) {
              if (items.hasCopayment) {
                setOpenModalPago(true);
                setObjPayment(responseCita.data.data.payment);
                setItems((prev) => ({
                  ...prev,
                  showModal: false,
                }));
              } else {
                setCurrentScreen("reservadoNoCopayment");
              }
            }
          }
        }
      } else {
        let d = {
          id: data.patient.linkPatient,
          active: false,
        };
        setCurrentScreen("linkObsolote");
        try {
          await Post({
            url: SAVE_LINK_PATIENT_AUTOAGENDAMIENTO,
            data: d,
            header: false,
          });
        } catch (error) {
          console.log(error);
        }
      }
    } catch (error) {
      console.log("error");
      console.log(error);
    }
  };

  const checkValidationDocument = (value) => {
    //console.log(getTipoDocumento(dataAcudiente.identityDocumentType, dataAcudiente.tipoDocumentoOpt))
    // if(getTipoDocumento(dataAcudiente.identityDocumentType, dataAcudiente.tipoDocumentoOpt)){
    //     setErrors(err=>({
    //         ...err,
    //         documentNumber: {
    //             error: true,
    //             text: 'Campo requerido'
    //         }
    //     }))
    //     setAllowDoAppt(false)
    // }else{
    if (value === "") {
      setErrors((err) => ({
        ...err,
        documentNumber: {
          error: true,
          text: "Campo requerido",
        },
      }));
      setAllowDoAppt(false);
    } else if (value.length < 5) {
      setErrors((err) => ({
        ...err,
        documentNumber: {
          error: true,
          text: "Debe tener una longitud mínima de 5 caracteres",
        },
      }));
      setAllowDoAppt(false);
    } else if (value.length > dataAcudiente.hasLength) {
      setErrors((err) => ({
        ...err,
        documentNumber: {
          error: true,
          text: `Debe tener una longitud máxima de ${dataAcudiente.hasLength} caracteres`,
        },
      }));
      setAllowDoAppt(false);
    } else {
      setErrors((err) => ({
        ...err,
        documentNumber: {
          error: false,
          text: "",
        },
      }));
      setAllowDoAppt(true);
    }
    //}
  };

  const onClickGoPayment = () => {
    setOpenModalPago(false);
    if (!objPayment || objPayment === undefined) {
      setCurrentScreen("failPayment");
    } else {
      setCurrentScreen("PENDING");
      setPayment(objPayment);
      window.open(objPayment.url, "_blank", "noopener,noreferrer");
    }
  };

  const shemaValidate = Yup.object().shape({
    choiceType: Yup.string().required(t("Camporequerido")),
  });

  return (
    <Row className={classTop}>
      <Col xs="12" md={{ span: 10, offset: 1 }}>
        <Card className="mt-2 mb-5 shadow-sm">
          <Card.Body className="p-5">
            <h5 className="colorLink mb-4 fw-700">Confirmar servicio</h5>
            <div className="my-3">
              <h6 className="colorLabel fw-700">Información del paciente</h6>
              <div className="colorLabel mb-2">
                <span className="fw-medium mr-2 fw-700">Paciente:</span>
                <span>{`${data.patient.name} ${data.patient.middleName} ${data.patient.lastName} ${data.patient.seccondSurname}`}</span>
              </div>
              <div className="colorLabel mb-2">
                <span className="fw-medium mr-2 fw-700">Teléfono:</span>
                <span>{`${data.patient.phoneNumber}${
                  data.patient.phoneNumber2 && `, ${data.patient.phoneNumber2}`
                }`}</span>
              </div>
              <div className="colorLabel mb-2">
                <span className="fw-medium mr-2 fw-700">
                  Correo electrónico:
                </span>
                <span>{`${data.patient.email}`}</span>
              </div>
            </div>
            <h5 className="colorLink mb-4 fw-700">Información del servicio</h5>
            <div className="my-3">
              <div className="colorLabel mb-2">
                <span className="fw-medium mr-2 fw-700">Tipo de servicio:</span>
                <span>Telemedicina (videollamada)</span>
              </div>
              <div className="colorLabel mb-2">
                <span className="fw-medium mr-2 fw-700">Especialidad:</span>
                <span>{data.especialidadName}</span>
              </div>
            </div>
            <div className="mb-3">
              <span className="colorLabel fw-medium mr-2 fw-700">
                Día y hora:
              </span>
              <span className="colorOrange date-time-help">
                {moment(data.hourInit, "DD-MM-YYYY HH:mm:ss").format(
                  "DD-MM-YYYY - HH:mm"
                )}{" "}
                hrs
              </span>
            </div>
            <div className="mb-4">
              <Formik
                initialValues={{
                  choiceType: "",
                }}
                validationSchema={shemaValidate}
                onSubmit={(values) => {
                  setItems((prev) => ({
                    ...prev,
                    choiceTypeInput: values.choiceType,
                    showModal: true,
                  }));
                }}
              >
                {({ errors, handleSubmit, setFieldValue, setFieldError }) => (
                  <Form onSubmit={handleSubmit}>
                    <div>
                      <label className="d-block font-weight-bold mr-5 colorLabel">
                        {t("dia_hora_debido_a")}:
                      </label>
                      <label
                        className={`mr-5 text-color-input d-block colorLabel ${
                          errors.choiceType ? "color-red" : ""
                        } text-secondary`}
                      >
                        {t("consulta_mas_cerca")}
                        <Field
                          type="radio"
                          name="choiceType"
                          value="closerAppointment"
                          className="ml-3"
                        />
                      </label>
                      <label
                        className={`mr-5 text-color-input colorLabel ${
                          errors.choiceType ? "color-red" : ""
                        } text-secondary`}
                      >
                        {t("cita_mejor_adapta")}
                        <Field
                          type="radio"
                          name="choiceType"
                          value="preferAppointment"
                          className="ml-3"
                        />
                      </label>
                      {errors.choiceType && (
                        <div className="invalid-feedback d-block">
                          {errors.choiceType}
                        </div>
                      )}
                    </div>
                    <div className="mt-4">
                      <button
                        className="mr-2"
                        onClick={() => setCurrentScreen("clbEspecialidad")}
                      >
                        Regresar
                      </button>
                      <button type="submit">{t("confirmar")}</button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>

            {configuration?.informationTelemedicine && (
              <div className="mb-3">
                <h5 className="colorLink mb-2">{t("telemedicina")}</h5>
                <p className="colorLabel">
                  {configuration.informationTelemedicine}
                </p>
              </div>
            )}
          </Card.Body>
        </Card>
      </Col>
      <Modal
        show={items.showModal}
        onHide={() => setItems((prev) => ({ ...prev, showModal: false }))}
        className="border-0"
        size="lg"
        backdrop={items.isReservating ? "static" : "nostatic"}
        keyboard={!items.isReservating}
      >
        <Modal.Body className="p-2">
          <div className="position-relative overflow-hidden">
            <h5 className="text-uppercase colorLabel">
              {t("consentimiento_telesalud")}
            </h5>
            <hr />
            <ConsentimientoTeleSalud
              namePaciente={`${data.patient.name} ${data.patient.middleName} ${data.patient.lastName} ${data.patient.seccondSurname}`}
              noDocumento={`${data.patient.identityDocumentType.code} ${
                data.patient.documentNumber
                  ? `: ${data.patient.documentNumber}`
                  : ""
              }`}
              nameDoctor={data.doctorName}
              nameAccount={data.patient.account.name}
              configuration={""}
              initialData={{
                account: data.patient.account,
                documentNumber: data.patient.documentNumber,
                identityDocumentTypeModel: data.patient.identityDocumentType,
                lastName: data.patient.lastName,
                doctorName: data.doctorName,
                name: data.patient.name,
                middleName: data.patient.middleName,
                seccondSurname: data.patient.seccondSurname,
                especialidadName: data.especialidadName,
              }}
              setDataRecord={setDataRecord}
              extraClass="colorLabel m-0"
            />
            <Row>
              <Col xs="12" md={{ span: 8, offset: 2 }}>
                <div className="border">
                  <SignatureCanvas
                    penColor="blue"
                    ref={sigCanvas}
                    canvasProps={{
                      width: 500,
                      height: 200,
                      border: "1px solid #000",
                    }}
                  />
                  {errors.firma.error && (
                    <span className="text-danger">{errors.firma.text}</span>
                  )}
                </div>

                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <Form.Check
                      className="color-354052 font-size-08rem font-weight-bold-600"
                      type="checkbox"
                      label="Aceptación de consentimiento por acudiente"
                      checked={dataAcudiente.aceptacionAcudiente}
                      onChange={(e) => {
                        setDataAcudiente((prev) => ({
                          ...prev,
                          aceptacionAcudiente: e.target.checked,
                        }));
                        if (!e.target.checked) {
                          setDataAcudiente((prev) => ({
                            ...prev,
                            identityDocumentType: "",
                            documentNumber: "",
                            patientRelationship: "",
                            fullName: "",
                          }));
                        }
                      }}
                    />
                  </div>
                  <div>
                    <button className="declined colorLabel" onClick={clear}>
                      Limpiar
                    </button>
                  </div>
                </div>

                {dataAcudiente.aceptacionAcudiente && (
                  <Row>
                    <Col xs="12" md="6">
                      <Form.Group>
                        <Form.Label className="font-weight-bold-600 text-secondary">
                          {t("tipo_documento")}{" "}
                          <span className="text-danger">*</span>
                        </Form.Label>
                        <Select
                          options={dataAcudiente.tipoDocumentoOpt.map((it) => ({
                            label: `${it.code}: ${it.name}`,
                            value: it.id,
                            code: it.code,
                            name: it.name,
                          }))}
                          value={
                            dataAcudiente.identityDocumentType
                              ? {
                                  label: `${
                                    dataAcudiente.tipoDocumentoOpt.find(
                                      (it) =>
                                        it.id ===
                                        dataAcudiente.identityDocumentType
                                    ).code
                                  }: ${
                                    dataAcudiente.tipoDocumentoOpt.find(
                                      (it) =>
                                        it.id ===
                                        dataAcudiente.identityDocumentType
                                    ).name
                                  }`,
                                  value: dataAcudiente.identityDocumentType,
                                }
                              : null
                          }
                          onChange={(value) => {
                            if (value) {
                              setDataAcudiente((prev) => ({
                                ...prev,
                                identityDocumentType: value.value,
                                hasLength: getLengthDN(value.code),
                              }));
                              setErrors((prev) => ({
                                ...prev,
                                identityDocumentType: {
                                  error: false,
                                  text: "",
                                },
                              }));
                            } else {
                              setDataAcudiente((prev) => ({
                                ...prev,
                                identityDocumentType: "",
                                hasLength: 10,
                              }));
                              setErrors((prev) => ({
                                ...prev,
                                identityDocumentType: {
                                  error: true,
                                  text: "Campo requerido",
                                },
                              }));
                            }
                          }}
                          placeholder="Selecciona una opción"
                          styles={{
                            control: (baseStyles, state) => ({
                              ...baseStyles,
                              height: "34px",
                              border: "1px solid #2A7EC3",
                              boxShadow: 0,
                              "&:hover": {
                                borderColor: "#2A7EC3",
                              },
                            }),
                          }}
                        />
                        {errors.identityDocumentType.error && (
                          <div className="invalid-feedback d-block">
                            {errors.identityDocumentType.text}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                    <Col xs="12" md="6">
                      <Form.Group>
                        <Form.Label className="font-weight-bold-600 text-secondary">
                          {t("documento_identidad")}{" "}
                          <span className="text-danger">*</span>
                        </Form.Label>
                        <input
                          type="text"
                          className={`form-input ${
                            errors.documentNumber.error && "error"
                          }`}
                          value={dataAcudiente.documentNumber}
                          onChange={(e) =>
                            setDataAcudiente((prev) => ({
                              ...prev,
                              documentNumber: e.target.value,
                            }))
                          }
                          onBlur={(e) =>
                            checkValidationDocument(e.target.value)
                          }
                        />
                        {errors.documentNumber.error && (
                          <div className="invalid-feedback d-block">
                            {errors.documentNumber.text}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                    <Col xs="12" md="6">
                      <Form.Group>
                        <Form.Label className="font-weight-bold-600 text-secondary">
                          Nombre completo <span className="text-danger">*</span>
                        </Form.Label>
                        <input
                          type="text"
                          className={`form-input text-uppercase ${
                            errors.fullName.error && "error"
                          }`}
                          value={dataAcudiente.fullName}
                          onChange={(e) => {
                            setDataAcudiente((prev) => ({
                              ...prev,
                              fullName: e.target.value.toUpperCase(),
                            }));
                            if (e.target.value) {
                              setErrors((prev) => ({
                                ...prev,
                                fullName: {
                                  error: false,
                                  text: "",
                                },
                              }));
                            } else {
                              setErrors((prev) => ({
                                ...prev,
                                fullName: {
                                  error: true,
                                  text: "Campo requerido",
                                },
                              }));
                            }
                          }}
                        />
                        {errors.fullName.error && (
                          <div className="invalid-feedback d-block">
                            {errors.fullName.text}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                    <Col xs="12" md="6">
                      <Form.Group>
                        <Form.Label className="font-weight-bold-600 text-secondary">
                          Parentesco <span className="text-danger">*</span>
                        </Form.Label>
                        <Select
                          options={dataAcudiente.tipoPacienteOpt.map((it) => ({
                            label: `${it.name}`,
                            value: it.id,
                          }))}
                          value={
                            dataAcudiente.patientRelationship
                              ? {
                                  label: dataAcudiente.tipoPacienteOpt.find(
                                    (it) =>
                                      it.id ===
                                      dataAcudiente.patientRelationship
                                  ).name,
                                  value: dataAcudiente.patientRelationship,
                                }
                              : null
                          }
                          onChange={(value) => {
                            if (value) {
                              setDataAcudiente((prev) => ({
                                ...prev,
                                patientRelationship: value.value,
                              }));
                              setErrors((prev) => ({
                                ...prev,
                                patientRelationship: {
                                  error: false,
                                  text: "",
                                },
                              }));
                            } else {
                              setDataAcudiente((prev) => ({
                                ...prev,
                                patientRelationship: "",
                              }));
                              setErrors((prev) => ({
                                ...prev,
                                patientRelationship: {
                                  error: true,
                                  text: "Campo requerido",
                                },
                              }));
                            }
                          }}
                          placeholder="Selecciona una opción"
                          styles={{
                            control: (baseStyles, state) => ({
                              ...baseStyles,
                              height: "34px",
                              border: "1px solid #2A7EC3",
                              boxShadow: 0,
                              "&:hover": {
                                borderColor: "#2A7EC3",
                              },
                            }),
                          }}
                        />
                        {errors.patientRelationship.error && (
                          <div className="invalid-feedback d-block">
                            {errors.patientRelationship.text}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                )}
              </Col>
            </Row>
            <div className="mt-3">
              <Form.Group className="text-center">
                <input
                  name="aceptarTerminos"
                  type="checkbox"
                  className="mr-2"
                  value={items.checkedTerm}
                  onChange={(e) =>
                    setItems((prev) => ({
                      ...prev,
                      checkedTerm: e.target.checked,
                    }))
                  }
                />
                <Form.Label className="fw-medium">{t("acepto")}</Form.Label>
              </Form.Group>
            </div>
            {items.isReservating ? (
              <div className="text-center">
                <Loading />
              </div>
            ) : (
              <div className="d-flex justify-content-center">
                <div className="mr-2">
                  <button
                    className="declined"
                    onClick={() =>
                      setItems((prev) => ({
                        ...prev,
                        openConfirmacionDeclinar: true,
                      }))
                    }
                  >
                    Declinar
                  </button>
                </div>
                <div>
                  <button
                    onClick={() => handleMakeAppointment(true)}
                    disabled={!items.checkedTerm}
                  >
                    Aceptar
                  </button>
                </div>
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
      {/*modal consentimiento declinado*/}
      <Modal
        show={items.openConfirmacionDeclinar}
        onHide={() =>
          setItems((prev) => ({ ...prev, openConfirmacionDeclinar: false }))
        }
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Body className="position-relative overflow-hidden">
          <h5 className="text-center mb-5 colorLabel">
            ¿Usted está seguro desea rechazar su consentimiento informado? Al
            seleccionar Si, no se podrá continuar con su atención médica?
          </h5>
          <Row className="text-center">
            <Col>
              <button
                onClick={() =>
                  setItems((prev) => ({
                    ...prev,
                    openConfirmacionDeclinar: false,
                  }))
                }
              >
                No
              </button>{" "}
              <button
                onClick={() => {
                  setItems((prev) => ({
                    ...prev,
                    openConfirmacionDeclinar: false,
                  }));
                  handleMakeAppointment(false);
                  setCurrentScreen("declinadoConsentimientoTLS");
                }}
              >
                Si
              </button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
      {/*modal confirmacion de pago */}
      <ModalInformacionParaPago
        cita={items.citaCostoMoneda}
        open={openModalPago}
        setOpen={setOpenModalPago}
        onClickGoPayment={onClickGoPayment}
        setPaymentStatus={setPaymentStatus}
        configuration={configuration}
        v1={false}
      />
    </Row>
  );
};

export default ClbConfirmarServicio;
